import { store } from '@/state/store';
import { local_words_with_related_words_upsert } from '@/state/words/local_words_with_related_words_upsert';
import { DTO__word } from '@shared/dto/+word/word_translated/DTO__word';
import { DTOWordWithRelatedWords } from '@shared/dto/+word/word_with_related_words/dto_word_with_related_words';
import { translate_word } from './_methods/translate_word';
import { SERVICE__translate_base } from './SERVICE__translate_base';

class ServiceTranslateWordsWithRelatedWords extends SERVICE__translate_base {
  /*
   * EVENTS
   */
  on_words_with_related_words_received(words_with_related_words: DTOWordWithRelatedWords[]) {
    for (let word_with_related_words of words_with_related_words) {
      let words_english = new Set<string>();

      for (let synonym of word_with_related_words.synonyms) {
        words_english.add(synonym.word_english);
      }

      for (let antonym of word_with_related_words.synonyms) {
        words_english.add(antonym.word_english);
      }

      this.register_words_dependency(word_with_related_words.word_english, Array.from(words_english));
    }
  }

  on_language_changed() {
    let slice_workspace = store.getState().slice_workspace;
    if (!slice_workspace.is_all_data_loaded) return;

    let slice_words = store.getState().slice_words;

    let words_with_related_words = Array.from(slice_words.words_with_related_words_map.values()).flatMap(inner_map => Array.from(inner_map.values()));

    //reset words for all words with related words to english or get translation from vocabulary
    for (let word_with_related_words of words_with_related_words) {
      word_with_related_words.antonyms = word_with_related_words.antonyms.map(translate_word);
      word_with_related_words.synonyms = word_with_related_words.synonyms.map(translate_word);
    }

    store.dispatch(local_words_with_related_words_upsert(words_with_related_words));
  }

  /*
   * METHODS
   */

  protected try_update_depended_entity_with_word(word: DTO__word) {
    let slice_words = store.getState().slice_words;
    let { user_settings } = store.getState().slice_user;

    let dependend_entities_ids = this.words_dependencies_map.get_or_create_set(word.word_english);

    let word_with_related_words_on_language = slice_words.words_with_related_words_map.get(user_settings.regional_language);
    if (!word_with_related_words_on_language) return;

    for (let entity_id of dependend_entities_ids) {
      let dependend_word_with_related_words = word_with_related_words_on_language.get(entity_id);
      if (!dependend_word_with_related_words) continue;

      dependend_word_with_related_words.antonyms = dependend_word_with_related_words.antonyms.map(antonym =>
        antonym.word_english == word.word_english ? word : antonym,
      );
      dependend_word_with_related_words.synonyms = dependend_word_with_related_words.antonyms.map(synonym =>
        synonym.word_english == word.word_english ? word : synonym,
      );

      store.dispatch(local_words_with_related_words_upsert([dependend_word_with_related_words]));
    }
  }
}

export const service_translate_word_with_related_words = new ServiceTranslateWordsWithRelatedWords();
